
import {
    GET_INCIDENT_FORM,
    RESET_INCIDENT_FORM,
    POST_INCIDENT_FORM_FAIL,
    POST_INCIDENT_FORM_SUCCESS,
    POST_INCIDENT_FORM
} from '../types/incident';


const initialState = {
    loading: true,
    form: null,
    error: null,
    creating: false,
    created: false
};


export default (state = initialState, action) => {

    switch (action.type) {
        case RESET_INCIDENT_FORM:
            return {
                ...state,
                loading: true,
                form: null,
                error: null,
                created: false
            };

        case GET_INCIDENT_FORM:
            return {
                ...state,
                loading: false,
                created: false,
                creating: false,
                form: (typeof action.response === 'string')? action.response: null,
                error: (typeof action.response === 'string')? null: action.response.error? action.response.error: 'Unable to get form at the moment!'

            };
        case POST_INCIDENT_FORM:
            return {
                ...state,
                creating: true,
                created: false
            };
        case POST_INCIDENT_FORM_SUCCESS:
            return {
                ...state,
                creating: false,
                created: true
            };
        case POST_INCIDENT_FORM_FAIL:
            return {
                ...state,
                creating: false,
                created: false,
                error: action.response.error? action.response.error: 'Unable to create report at the moment!'
            };
        default:
            return state
    }
}




// WEBPACK FOOTER //
// ./src/reducers/incident.js